import Link from 'next/link';

import { Menu } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@kit/ui/dropdown-menu';
import { NavigationMenu, NavigationMenuList } from '@kit/ui/navigation-menu';
import { Trans } from '@kit/ui/trans';

import { SiteNavigationItem } from './site-navigation-item';

const links = [
  { label: 'marketing:platform', path: '/#platform' },
  { label: 'marketing:axcelerate', path: '/axcelerate' },
  { label: 'marketing:pricing', path: '/pricing' },
  { label: 'marketing:contact', path: '/contact' },
];

export function SiteNavigation() {
  return (
    <>
      <div className="hidden items-center justify-center lg:flex">
        <NavigationMenu aria-label="Main navigation">
          <NavigationMenuList className="gap-x-5 xl:gap-x-7">
            {links.map((item) => (
              <SiteNavigationItem key={item.path} path={item.path}>
                <Trans i18nKey={item.label} />
              </SiteNavigationItem>
            ))}
          </NavigationMenuList>
        </NavigationMenu>
      </div>
      <div className="flex justify-start lg:hidden">
        <DropdownMenu>
          <DropdownMenuTrigger
            className="hover:bg-muted focus-visible:ring-ring flex h-11 w-11 items-center justify-center rounded-full focus-visible:ring-2"
            aria-label="Open navigation menu"
          >
            <Menu className="h-5 w-5" aria-hidden />
          </DropdownMenuTrigger>
          <DropdownMenuContent align="start" className="min-w-56 p-2">
            {links.map((item) => (
              <DropdownMenuItem key={item.path} asChild>
                <Link
                  className="flex min-h-11 w-full items-center px-3"
                  href={item.path}
                >
                  <Trans i18nKey={item.label} />
                </Link>
              </DropdownMenuItem>
            ))}
            <DropdownMenuItem asChild>
              <Link
                className="flex min-h-11 w-full items-center px-3"
                href="/auth/sign-in"
              >
                <Trans i18nKey="auth:signIn" />
              </Link>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </>
  );
}
